import { useCallback } from 'react';
import en from '../locales/en.json';

export const useLocale = () => {
  const currentLocale = 'en';

  // Get translated text with support for nested keys
  const t = useCallback((key, defaultValue = '') => {
    const keys = key.split('.');
    let value = en;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return defaultValue;
      }
    }
    
    return typeof value === 'string' ? value : defaultValue;
  }, []);

  // Interpolate variables in strings
  const interpolate = useCallback((str, variables = {}) => {
    return str.replace(/\{\{(\w+)\}\}/g, (match, key) => {
      return variables[key] !== undefined ? variables[key] : match;
    });
  }, []);

  return {
    currentLocale,
    t,
    interpolate,
  };
};
